import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/pages/index/index')
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('@/pages/about/index'),
      meta: { index: 0 }
    },
    {
      path: '/service',
      name: 'Service',
      component: () => import('@/pages/service/index'),
      meta: { index: 1 }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('@/pages/contact/index'),
      meta: { index: 2 }
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js